var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  fillRule: "evenodd",
  d: "M33.335 14h-10.67a.67.67 0 0 0-.665.665v10.67a.67.67 0 0 0 .665.665h5.745v-4.64h-1.56v-1.815h1.56V18.21c0-1.55.945-2.395 2.335-2.395.465 0 .93 0 1.395.07V17.5h-.955c-.755 0-.9.36-.9.885v1.155h1.8l-.235 1.815h-1.565V26h3.05a.67.67 0 0 0 .665-.665v-10.67a.67.67 0 0 0-.665-.665",
  clipRule: "evenodd"
})));
export default SvgMillustrationsFacebook;